import React, { FunctionComponent, ReactNode, MouseEvent } from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';

import DropzonePreviewItem from './DropzonePreviewItem';
import { DropdownActions } from '../DropdownActions';


export interface IDropzoneCardProps extends DropzoneOptions {
  placeholder?: string | ReactNode;
  disabled?: boolean;
  loading?: boolean;
  actions?: any[];
  files?: any;
  title?: string | ReactNode;
  rejectedFiles?: any;
  t?: any,
  handleRemove?: (index: number, isRejected: boolean) => (e: MouseEvent<HTMLAnchorElement>) => void;
}

export const DropzoneCard: FunctionComponent<IDropzoneCardProps> = ({
  title,
  placeholder,
  disabled,
  loading,
  files = [],
  rejectedFiles = [],
  actions,
  children,
  t,
  ...props }) => {
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject
  } = useDropzone(props);
  const inputProps = getInputProps({
    className: 'form-control w-100',
    disabled: disabled || loading,
  });

  return (
    <div className="card">
      <div className="card-body">
        <div className="dropzone dropzone-multiple dz-clickable">
          <ul className="dz-preview dz-preview-multiple list-group list-group-lg list-group-flush">
            {Boolean(files.length) && files.map((file: { name: string; size: string; }, index: number) => (
              <li key={file.name + '-' + file.size + '-' + index} className="list-group-item px-0 dz-processing">
                <DropzonePreviewItem name={file.name}
                  size={file.size}
                  removable={!actions}
                  handleRemove={props.handleRemove && props.handleRemove(index, false)}
                >
                  {actions && actions.length && <DropdownActions actions={actions} />}
                </DropzonePreviewItem>
              </li>
            ))}
            {Boolean(rejectedFiles.length) && rejectedFiles.map((file: { name: string; size: string; reason: any; }, index: number) => (
              <li key={file.name + '-' + file.size + '-' + index} className="list-group-item px-0 dz-processing">
                <DropzonePreviewItem key={file.name + '-' + file.size + '-' + index}
                  name={file.name}
                  size={Number(file.size)}
                  reason={file.reason}
                  removable={!actions}
                  handleRemove={props.handleRemove && props.handleRemove(index, true)}
                >
                  {actions && actions.length && <DropdownActions actions={actions} />}
                </DropzonePreviewItem>
              </li>
            ))}
          </ul>
          <div {...getRootProps({ className: 'dz-details dz-message' })}>
            <input {...inputProps}/>
            {!loading && (
              <>
                <div>
                  <i className="fe fe-file d-inline-block align-middle" />
                  {title}
                </div>
                {isDragAccept && (<span className="text-success">{t('All files will be accepted')}</span>)}
                {isDragReject && (<span className="text-danger">{t('Some files will be rejected')}</span>)}
                {!isDragActive && (
                  <>
                    {typeof placeholder === 'string' ? (<span className="text-secondary">{placeholder}</span>) : placeholder}
                  </>
                )}
              </>
            )}
            {loading && <span>{t('Loading..')}.</span> }
          </div>
        </div>
      </div>
    </div>
  );
};

DropzoneCard.defaultProps = {
  disabled: false,
  loading: false,
  files: [],
  rejectedFiles: [],
  t: (key: string) => key,
  placeholder: 'Drop files here',
};

export default DropzoneCard;
